import {
	Directive,
	ElementRef,
	HostListener,
	Input,
	OnChanges,
	Renderer2,
	SimpleChanges
} from "@angular/core";

@Directive({
	selector: '[cpDisable]',
})
export class DisableDirective implements OnChanges {

	@Input() cpDisable : boolean = true;

	constructor(public elementRef: ElementRef, private renderer: Renderer2) {
	}

	@HostListener('focusin')
	onFocusIn() {
		// disable keyboard interaction
		if (this.cpDisable) {
			this.elementRef.nativeElement.ownerDocument.activeElement.blur();
		}
	}

	public ngOnChanges(changes: SimpleChanges) {
		const {cpDisable} = changes;

		if (cpDisable && this.elementRef) {
			this.updateHostElementClass(this.elementRef.nativeElement);
		}
	}

	private updateHostElementClass(nativeElement: any) {
		if (this.cpDisable) {
			// disable mouse interaction
			this.renderer.addClass(nativeElement, "cpDisabledElement");
		} else {
			this.renderer.removeClass(nativeElement, "cpDisabledElement");
		}
	}
}
